<template>
  <div id="app">
    <header class="topbar">
      <div class="brand">MBH3 Katalog Stanova - MASTER PROJEKT</div>
      <nav>
        <router-link to="/">Galerija</router-link>
      </nav>
    </header>
    <router-view />
  </div>
</template>

<style lang="scss">
#app {
  --ink: #11222d;
  --accent: #d65a31;
  --muted: #536471;
  --line: #d6dde3;

  font-family: 'Trebuchet MS', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--ink);
  min-height: 100vh;
  background:
    radial-gradient(circle at 10% 20%, #f4efe7 0%, transparent 45%),
    radial-gradient(circle at 85% 10%, #dcecf6 0%, transparent 42%),
    linear-gradient(180deg, #fdfcf9 0%, #f5f8fb 100%);
}

.topbar {
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid var(--line);
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
}

.brand {
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

nav {
  display: flex;
  gap: 8px;

  a {
    display: inline-block;
    padding: 8px 12px;
    border-radius: 999px;
    font-weight: 700;
    text-decoration: none;
    color: var(--ink);
    transition: 0.2s ease;
    border: 1px solid transparent;

    &:hover {
      border-color: var(--line);
      color: var(--accent);
    }

    &.router-link-exact-active {
      background: #fff;
      border-color: #f1c4b6;
      color: var(--accent);
    }
  }
}
</style>
